<template>
    <div class="size-full">
        <product-renderer />
        <rotatable-item-indicator />
    </div>
</template>

<script>
    import ProductRenderer from '../ProductRenderer.vue';
    import RotatableItemIndicator from '../UI/RotatableItemIndicator.vue';

    export default {
        components: {
            ProductRenderer,
            RotatableItemIndicator,
        },
    };
</script>
